import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components/ui/card';
import { Construction } from 'lucide-react';

/**
 * Placeholder component for pages under development
 */
const PlaceholderPage = ({ title, description }) => {
  return (
    <div className="flex items-center justify-center h-full p-6">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center gap-3">
            <Construction className="h-8 w-8 text-primary" />
            <CardTitle className="text-2xl">{title || 'Coming Soon'}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            {description || 'This feature is currently under development and will be available soon.'}
          </p>
          <div className="mt-6 p-4 bg-muted rounded-lg">
            <p className="text-sm font-medium">Development Status:</p>
            <ul className="mt-2 space-y-1 text-sm text-muted-foreground">
              <li>✅ Database schema designed</li>
              <li>✅ Component structure planned</li>
              <li>🔄 UI development in progress</li>
              <li>⏳ Integration pending</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlaceholderPage;
